<template>
    <div class="pie_chart" :style="'width:' + width +'; min-height: '+ height+';'"></div>
</template>

<script>

export default {
    name: "pie_chart",
    props: {
        width: {
            type: String,
            default: '100%'
        },
        height: {
            type: String,
            default: '500px'
        },
        values: {
            type: [Array, Object],
            default: () => {
            }
        },
        fields: {
            type: Array,
            default: () => {
            }
        },
        title: {
            type: String,
            default: ''
        },
        colors: {
            type: Array,
            default: null
        },
        zoom: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        pie_options() {
            return {
                ...this.get_colors(),
                title: {
                    text: this.title,
                    left: 'center'
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: this.fields
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                series: [{
                    data: this.get_values(),
                    type: 'pie',
                    label: {
                        formatter: '{b}: {c} ',
                    }
                }],
                ...this.has_zoom()
            }
        }
    },
    watch: {
        values: {
            deep: true,
            handler() {
                this.draw_chart();
            }
        }
    },
    mounted() {
        this.draw_chart();
    },
    methods: {
        has_zoom: function () {
            if (this.zoom) {
                return {
                    dataZoom: [
                        {
                            show: true,
                            start: 0,
                            end: 100
                        }
                    ]
                }
            }
            return {};
        },
        get_colors: function () {
            if (this.colors === null) {
                return {};
            }
            return {color: this.colors}
        },
        get_values: function () {
            const items = [];
            Object.entries(this.values).forEach(entry => {
                items.push({
                    name: entry[0],
                    value: entry[1]
                });
            });

            return items;
        },
        get_legends: function () {
            return Object.keys(this.values);
        },
        draw_chart() {
            if (Object.keys(this.values).length > 0) {
                this.chart = echarts.init(this.$el);
                this.chart.setOption(this.pie_options);
            }
        }
    }
}
</script>
